import request from '@/util/server.js'
// 首页模块

//  首页-行业咨询
export function getConsultList (params) {
  return request({
    url: '/industry/list',
    method: 'post',
    data: params
  })
}

//  首页-行业咨询
export function getConsultInfo (params) {
  return request({
    url: '/industry/info',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home/consult.js